module.exports = __webpack_public_path__ + "static/media/SPRAY4.a004de60.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/SPRAY4.png
// module id = 286
// module chunks = 0